import { Component, Input, QueryList, ContentChildren, OnInit } from '@angular/core';
import { PageInfo } from '../../interfaces/pageInfo';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MenuTriggerForDirective } from '../../directives/menu-trigger-for.directive';
import { IconComponent } from '../icon/icon.component';
import { MenuComponent } from '../menu/menu.component';

// Component for displaying the page header. Accepts a PageInfo input, which is created by he PageInfoService.
@Component({
    selector: 'gbc-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    imports: [BreadcrumbComponent, RouterLink, MenuTriggerForDirective, IconComponent, MenuComponent, AsyncPipe]
})
export class PageHeaderComponent {
  @Input() public pageInfo: PageInfo;
  @Input() public backRoute?: string;

  @ContentChildren(MenuItemComponent) public menuItems: QueryList<MenuItemComponent>;
}
